<div class="game-container">
  <div class="header">
    <div class="video-container">
      <div class="timer">
        <app-timer-v3 [countdown]="countdown" *ngIf="countdown > 0"></app-timer-v3>
      </div>

      <app-live-video></app-live-video>
    </div>
  </div>

  <div class="betting-section">
    <app-please-stand-by *ngIf="standby"></app-please-stand-by>

    <div class="betting-container">
      <app-bet-confirmation-alert
        [bet]="currentBet.type"
        [chips]="currentBet.chips"
        [show]="betConfirmed"
        (onEnded)="betConfirmed = false"
        *ngIf="betConfirmed"
      ></app-bet-confirmation-alert>
      <div class="">
        <app-cards-deal></app-cards-deal>
      </div>

      <div class="mt-4" [class.opacity-50]="!_betService.allowBet">
        <app-win-streak></app-win-streak>
      </div>
      <div class="mt-4" [class.opacity-50]="!_betService.allowBet">
        <app-bet-section></app-bet-section>
      </div>
    </div>
    <div class="px-1">
      <app-current-bets></app-current-bets>
    </div>
    <div class="history-container-sm">
      <app-trend></app-trend>
    </div>
  </div>
  <div class="history-container-md">
    <app-trend></app-trend>
  </div>
</div>

<app-live-messages
  [messages]="rushLiveMessages"
  [type]="liveMessageTypeEnum.RUSH"
  [isAdmin]="false"
></app-live-messages>
